import React from "react";
import { getLeadStatusDefinition } from "../constants/leadStatuses";

export const LEAD_STATUS_ICON_SIZE = 20;
export const LEAD_STATUS_ICON_STROKE = 2;

export default function LeadStatusIcon({
  status,
  size = LEAD_STATUS_ICON_SIZE,
  color,
  strokeWidth = LEAD_STATUS_ICON_STROKE,
  style,
  className,
}) {
  const def = getLeadStatusDefinition(status);
  const Icon = def.Icon;

  return (
    <Icon
      size={size}
      color={color ?? def.color}
      strokeWidth={strokeWidth}
      style={{ flexShrink: 0, ...style }}
      className={className}
    />
  );
}
